import React, { useState, useEffect } from "react";
import { useQuery, useQueries, useQueryClient } from 'react-query'
import { getResultsRSC, getResultsPhase, getUnits, getPhases, getCumulativeResult } from "data/Querys"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { getPhaseRSC, getLongPhaseRSC, getLevelRSC, getLongEventRSC, getEventRSC, clearEventModifier } from 'helpers/rsc'
import NotAvailable from "components/common/NotAvailable";
import Loader from 'components/general/Loader'
import { isLiveStatus, isStartListStatus } from "helpers/status";
import Label from "components/general/Label";
import { SimpleProgressBar } from "components/general/ProgressBar";
import { findArray } from 'helpers/utils'
import { getIsTracks } from "components/sports/ath/helper/AthHelpers";
//Results
import AthResults from 'components/sports/ath/views/AthResults'
//Results
import AthAnalysis from 'components/sports/ath/views/AthAnalysis'
//Summary
import AthSummary from 'components/sports/ath/views/AthSummary';
//
import AthCombinedPoints from 'components/sports/ath/views/AthCombinedPoints';
//Records
import RecordsPrototype from 'components/general/RecordsPrototype'
//Helpers
import { hasSummary, getIsEventCombined, getIsEventRoad, getIsCombiExceptions, isPhaseFinal, isPhaseQual, CATEGORY, COMBINED, getIsEventDecathlon } from 'components/sports/ath/helper/AthHelpers'
//QualificationRule Component
import ProgressionRule from "components/common/ProgressionRule";
//Page Headers 
import PageHeader from "components/common/PageHeader";
import CurrentCompetitor from 'components/sports/ath/general/CurrentCompetitor'
import PreviousCompetitor from 'components/sports/ath/general/PreviousCompetitor'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useEventUnit } from "components/common/EventUnit"
import { Card } from "react-bootstrap";
import FooterEG2023 from "components/common/main-container/EG2023/footer";


const AthContext = () => {
    const [key, setKey] = useState('results');
    const { mirs_competition, mirs_discipline, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
    const _phase = getPhaseRSC(mirs_rsc);
    const _longPhase = getLongPhaseRSC(mirs_rsc);
    const _event = getEventRSC(mirs_rsc)
    const eu = useEventUnit()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    let filterScheduled = getLevelRSC(mirs_rsc) === 'PHASE' && !getIsCombiExceptions(mirs_rsc) ? 'S' : 'Y'

    //GET UNITS IN PHASE

    const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
        {
            queryKey: ['unitsPhase', mirs_competition, mirs_language, _phase, filterScheduled],
            queryFn: getUnits,
            //refetchInterval: 30000,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        }
    );


    /*
        let unitsLoading = false;
        let unitsError = false;
    
        const queryClient = useQueryClient();
        const unitsFromPhase = queryClient.getQueryData(['phasesData', mirs_competition, mirs_language, _event]);
        const unitsData = unitsFromPhase?.find(item => item.code === mirs_rsc)
    */

    const { data: dataCombined, isError: isErrorCombined, isLoading: isLoadingCombined } = useQuery(
        {
            queryKey: ['combinedPhases', mirs_competition, mirs_language, _event, 'Y'],
            queryFn: getPhases,
            //refetchInterval: 30000,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        }
    );

    let queryArray = [];

    let recordArray = mirs_competition === 'EG2023' ? ['ER', 'CR'] : ['OR', 'WR']
    let recordEvent = mirs_competition === 'EG2023' ? clearEventModifier(mirs_rsc) : undefined

    //GET ALL RESULTS IN PHASE 
    unitsData?.phase?.units?.forEach((unit) => {
        queryArray.push({
            queryKey: ['resultsData', mirs_competition, unit.code, mirs_language, _longPhase, undefined, recordArray, undefined, recordEvent],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });

    //RESULTS ONE ONLY 
    /*
    const { data: dataOld, isError: errorOld, isLoading: isLoadingOld } = useQuery(
        {
            //const [_key, _competition, _rsc, _language, _rscConfig, subcode] = queryKey
            queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language, _phase],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            //onError: (error) =>
            //    console.error(`Something went wrong: ${error.message}`),
        });
*/


    //SUMMARY (Poner dentro de array de datos quye se recuperan)
    const { data: phaseResult } = useQuery(
        {
            queryKey: ['resultsPhaseSummary', mirs_competition, getPhaseRSC(mirs_rsc), mirs_language],
            queryFn: getResultsPhase,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        });

    // Cumulative data
    const { data: cumulativeData, isError: isErrorCum, isLoading: isLoadingCum } = useQuery({
        queryKey: ['CombinedPoints', mirs_competition, mirs_language, getLongEventRSC(mirs_rsc)],
        queryFn: getCumulativeResult,
        refetchInterval: 5000,
        staleTime: 5000,
        refetchIntervalInBackground: true,
        notifyOnChangeProps: ['data', 'error'],
        onError: (error) =>
            console.error(`Something went wrong: ${error.message}`),
    });

    const results = useQueries(queryArray);
    const isLoading = unitsLoading || results.some(result => result.isLoading)
    const isError = unitsError || results.some(result => result.isError)


    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }

    //Get units with results , discarts facke units associated to phase or not started in order not show 
    const realData = results.filter(res => res.data.results)
    const data = realData[0]?.data;
    if (!data) { return <NotAvailable /> }


    //get values from first result in order to decide rece type

    const type = findArray(data?.config?.extendedConfig, { code: ['CATEGORY'] }).value
    const isFinal = isPhaseFinal(mirs_rsc);
    const isQual = isPhaseQual(mirs_rsc);

    const filtersQualRule = {
        ei_type: ['UI'],
        ei_code: ['QUAL_RULE']
    };

    const isEventRoad = getIsEventRoad(mirs_rsc);
    const isEventCombined = getIsEventCombined(mirs_rsc);
    const isEventDecathlon = getIsEventDecathlon(mirs_rsc);
    const isTracks = getIsTracks(mirs_rsc);

    let dataHeader = unitsData?.phase?.description
    let compHeader = results.length > 1 ?
        dataHeader && <PageHeader title={dataHeader} />
        : data && <PageHeader data={data} />

    const isStartingLine = findArray(data?.config?.extendedConfig, { code: ['START_IN_LANES'] })?.value === 'Y' ? true : false
    const resultStatus = data?.results?.status?.code;

    let tabTitle = isEventRoad && isStartListStatus(resultStatus) ? "HeaderStartList" : "HeaderResults";
    tabTitle = (isStartingLine && !isFinal) || (isTracks && !isFinal) ? "Heats" : tabTitle;
    tabTitle = (CATEGORY.VJUMPS && isQual) || (CATEGORY.HJUMPS && isQual) || (CATEGORY.THROWS && isQual) ? "Groups" : tabTitle

    const intermediates = []
    // Array.isArray(unitsData?.phase?.units) && unitsData?.phase?.units.forEach((unit, index) => {

    let events = ''
    isEventDecathlon ? events = COMBINED.DECATHLON : events = COMBINED.HEPTATHLON

    events.forEach((phase, index) => {
        let nodePhase = dataCombined?.find(item => item?.code === getPhaseRSC(phase))
        let status = nodePhase?.units?.find(item => item.code === phase)?.schedule?.status?.code
        let unitDesc = eu(phase, true)
        intermediates.push(
            {
                "code": phase,
                "value": unitDesc,
                "pos": index,
                "status": status,
            }
        )
    })
    const current = intermediates.find(item => item.code === mirs_rsc)
    const progressBarData = {
        "currentPosition": current?.pos,
        "finalPosition": 2,
        "intermediates": intermediates
    }
    const numElements = intermediates.length;

    let qualificationStandart = findArray(data?.results?.extendedInfos, { ei_code: ['QUAL_BP'], ei_pos: ['1'] })?.ei_value

    //Needed to add bib and order column to previous and current competitor, checks if there is only one group at a time
    let prevCurrIsOneGroup
    if (type !== CATEGORY.RACE) {
        let currOrPrevGroups = results?.filter(res => res?.data?.results?.currentCompetitorResult || res?.data?.results?.previousCompetitorResult)
        prevCurrIsOneGroup = currOrPrevGroups.length <= 1
    }
    //Used for collapse on results
    const numHeats = results.length

    return (
        <>

            {compHeader}
            <div className='mirs-page-container'>
                {data?.records && <RecordsPrototype records={data.records} />}
                {progressBarData && isEventCombined && <SimpleProgressBar key="progressbar-component" id={`mirs-progressbar-${mirs_rsc}`} data={progressBarData} numElements={numElements} />}
                {/* PREVIOUS & CURRENT */}
                {type !== CATEGORY.RACE &&
                    <div className='row'>
                        {results.map((res, index) => {
                            if (res.data?.results?.items !== undefined) {
                                let sw = isLiveStatus(res?.data?.results?.status?.code)
                                return (
                                    sw &&
                                    <div key={`previous-current-component-${index}`} className="col-12 col-sm">
                                        <div><h4 className="text-dark">{res?.data?.results?.eventUnit?.shortDescription}</h4></div>
                                        {res?.data?.results.previousCompetitorResult && <PreviousCompetitor data={res?.data?.results?.previousCompetitorResult} type={type} isOneGroup={prevCurrIsOneGroup} />}
                                        {res?.data?.results.currentCompetitorResult && <CurrentCompetitor data={res?.data?.results?.currentCompetitorResult} type={type} isOneGroup={prevCurrIsOneGroup} />}
                                    </div>
                                )
                            }
                        })
                        }
                    </div>
                }

                {qualificationStandart && <Card className={`qualification-rule p-2 mt-1 mb-3`} >
                    <Label data={'QualStandart'} />: {qualificationStandart}
                </Card>}
                <ProgressionRule key="progress-component" data={data?.results?.extendedInfos} filter={filtersQualRule} itemData={'ei_value'} />

                <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-3 mirs-tab-result"
                >

                    <Tab eventKey="results" title={<Label data={tabTitle} />}>
                        {results.map((res, index) => {
                            if (res?.data?.results?.items !== undefined)

                                return <AthResults key={`results-component-${index}`} data={res.data} numHeats={numHeats}/>
                        })
                        }
                    </Tab>

                    {isEventRoad && <Tab eventKey="analisis" title={<Label data="HeaderRaceAnalysis" />}>
                        <div><AthAnalysis data={data}></AthAnalysis></div>
                    </Tab>}

                    {(unitsData?.phase?.units.length > 1 || isEventCombined) &&
                        <Tab eventKey="summary" title={<Label data="LabelSummary" />}>
                            {phaseResult?.phaseResults && <AthSummary data={phaseResult} />}
                        </Tab>
                    }

                    {isEventCombined && <Tab eventKey="combinedPoints" title={<Label data="HeaderCombinedPts" />}>
                        <AthCombinedPoints data={cumulativeData}></AthCombinedPoints>
                    </Tab>}
                </Tabs>
            </div>

        </>
    );
};

export default AthContext;

